module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"examQuestionCount":"Anzahl der Prüfungsfragen","title":"Bezeichnung"},"en":{"examQuestionCount":"Exam question count","title":"Title"}}')
  delete Component.options._Ctor
}
